import strings from 'owa-strings/owa-options-strings';
import * as React from 'react';
import { OptionsCheckbox } from 'owa-options-controls';
import setShowWeekNumbersOption from '../data/mutators/setShowWeekNumbersOption';
import { observer } from 'mobx-react';
import getShowWeekNumbers from '../selectors/getShowWeekNumbers';

/**
 * The ShowWeekNumbers parameter specifies whether the week number is
 * displayed in the Outlook on the web calendar. Valid values are: true, false
 */
export default observer(function ShowWeekNumbers() {
    const onShowWeekNumbersChange = (
        ev?: React.FormEvent<HTMLElement | HTMLInputElement>,
        checked?: boolean
    ) => {
        setShowWeekNumbersOption(checked);
    };

    return (
        <OptionsCheckbox
            ariaLabel={strings.options_weekNumbers_showWeekNumbers}
            label={strings.options_weekNumbers_showWeekNumbers}
            checked={getShowWeekNumbers()}
            onChange={onShowWeekNumbersChange}
        />
    );
});
